import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../../services/toast.service';

export const moduloGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastService);
  
  const requiredModulo = route.data?.['modulo'] as string;
  const user = auth.currentUser();
  const userModulos = user?.modulos || [];

  if (requiredModulo) {
    if (userModulos.includes('*') || userModulos.includes(requiredModulo)) {
      return true;
    }
    toast.error('Tu taller no cuenta con este módulo. Contacta a soporte.');
    return router.createUrlTree(['/dashboard']);
  }
  
  return true;
};
